export default __webpack_public_path__ + "static/media/Inc42-logo.48a2e361.svg";